// extracted by mini-css-extract-plugin
export default {"container":"uG-z","disabled":"vG-z","bgBlack":"wG-z","content":"xG-z","countdown":"yG-z","topCaption":"zG-z","topHeading":"AG-z","heading":"BG-z","copy":"CG-z"};